import service from "./service";

/**
 * POST /uploads — stores a base64-encoded file and answers with its fileName
 * and path.
 * @param {{ fileBase64: string, fileName: string }} payload
 */
const uploadFile = async (payload) => {
  return service.post("/uploads", payload).then((response) => {
    return response;
  });
};

const uploadsService = {
  uploadFile,
};

export default uploadsService;
